/**
 * Away-only desktop notifications for long-running builds (Codex model:
 * turn-complete / needs-input / needs-approval). Fires ONLY when the tab is
 * hidden — a visible panel already shows everything — and coalesces per
 * session via the notification tag.
 */

const supported = () => typeof window !== 'undefined' && 'Notification' in window

/** Ask once, from a user gesture (the first send). 'denied' is never re-asked. */
export const ensureNotifyPermission = (): void => {
  if (!supported() || Notification.permission !== 'default') return
  void Notification.requestPermission()
}

export const notifyIfHidden = (title: string, body: string, tag: string): void => {
  if (!supported()) return
  if (document.visibilityState === 'visible') return
  if (Notification.permission !== 'granted') return
  try {
    const n = new Notification(title, { body, tag })
    n.onclick = () => {
      window.focus()
      n.close()
    }
  } catch {
    // Some platforms throw from the constructor (e.g. Android Chrome requires
    // a ServiceWorker registration) — a missed heads-up must never break the run.
  }
}
